import { createFileRoute } from '@tanstack/react-router';

import { LandSearchPage } from '@/features/land/land-search-page';

export const Route = createFileRoute('/_app/land/')({ component: LandSearchPage });
